<template>
  <div class="foot-box">
    <div class="foot-content">
      <div>友情连接：</div>
      <div class="links-box">
        <a href="http://rst.shanxi.gov.cn" target="_blank">山西省人力资源和社会保障厅</a>
        <a href="http://zscx.osta.org.cn" target="_blank">国家职业资格证书全国联网查询</a>
        <a href="https://www.sjrc.com.cn" target="_blank">山西人才网</a>
      </div>
      <div class="contentI">
        <div>
          <div>咨询电话</div>
          <div class="font-red">03517036361</div>
        </div>
        <div>
          <div>公司地址：太原高新区创业街19号1幢14号1411号</div>
          <div>网址：http://www.skill18.com/</div>
        </div>
        <div class="code">
<!--          <div class="img-box">-->
<!--            <img src="../assets/img/ios.png" alt="">-->
<!--            <div>IOS下载</div>-->
<!--          </div>-->
          <div class="img-box">
            <img src="http://www.skill18.com:9003/appdownload.png" alt="">
            <div>APP下载</div>
          </div>
        </div>
      </div>
      <div class="contentII">
        <div>
          <div>Copyright © 2020-2025技通天下学习平台</div>
          <div>技术支持：太原安德智能科技有限公司</div>
        </div>
        <div>
          <a href="https://beian.miit.gov.cn" target="_blank">备案号：晋ICP备18010754号-12</a>
        </div>
        <div>
          <a href="index.html">首页</a> -
          <a href="course.html">发现课程</a> -
          <a href="news.html">新闻公告</a> -
          <a href="teachers.html">名师专题</a> -
          <a href="class.html">公开课</a> -
          <a href="contact us.html">联系我们</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footMenu'
}
</script>

<style lang="scss" scoped>
.foot-box{
  width: 100%;
  background: #3A3B3E;
  padding: 30px;
  color: #b3b3b3;
  font-size: 16px;
  .foot-content{
    width: 1200px;
    margin: 0px auto;
    .links-box{
      margin-top: 10px;
      a{
        padding-right: 30px;
      }
    }
    .contentI{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .font-red{
        font-size: 30px;
        color: #ce443a;
      }
      .code{
        display: flex;
        .img-box{
          text-align: center;
          font-size: 12px;
          color: #ffffff;
          margin-left: 15px;
          img{
            width: 100px;
            height: 100px;
            margin-bottom: 5px;
          }
        }
      }
    }
    .contentII{
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #666;
      padding-top: 30px;
      font-size: 12px;
    }
  }
  a{
    color: #b3b3b3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue